export const selectScopesConfigDomain = () => (state) => state.scopes;
export const selectIsFromRegistration = () => (state) =>
  state.app.query.from === 'activation';
